var map = {
	"./Johor.png": "9c8f",
	"./Kedah.png": "93f4",
	"./Kelantan.png": "1b15",
	"./KualaLumpur.png": "ed89",
	"./Malacca.png": "b68b",
	"./NegeriSembilan.png": "dd74",
	"./Pahang.png": "30f3",
	"./Penang.png": "dc5b",
	"./Perak.png": "d33f",
	"./Perlis.png": "cb07",
	"./Sabah.png": "05ec",
	"./Sarawak.png": "209d",
	"./Selangor.png": "26c7",
	"./Terengganu.png": "392f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0580";